import type { FieldKey } from '@jira/polaris__domain-field/src/FieldKey.types.tsx';
import { fireCompoundAnalyticsEvent } from '@jira/polaris__lib-analytics/src/fireCompoundAnalyticsEvent.tsx';
import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next/types';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import type { Props, State } from './FieldsUpdate.types.tsx';

const getUpdatedState = (state: State, fieldKey: FieldKey, description: string | undefined) => ({
	...state,
	fields: {
		...state.fields,
		[fieldKey]: {
			...state.fields[fieldKey],
			description,
		},
	},
});

export const updateDescription =
	(fieldKey: string, description: string, createAnalyticsEvent: CreateUIAnalyticsEvent) =>
	async (
		{ getState, setState }: StoreActionApi<State>,
		{ onFieldUpdateFailed, fieldRemote }: Props,
	): Promise<void> => {
		const state = getState();
		const oldDescription = state.fields[fieldKey].description;

		if (!state.fields[fieldKey] || state.fields[fieldKey].description === description) {
			return;
		}

		setState(getUpdatedState(state, fieldKey, description));

		try {
			const newFieldState = await fieldRemote.updateField({
				fieldKey,
				description,
			});
			setState(getUpdatedState(getState(), fieldKey, newFieldState.description));
			// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (err: any) {
			setState(getUpdatedState(getState(), fieldKey, oldDescription));

			fireCompoundAnalyticsEvent.FieldConfig.descriptionChangedFailure(createAnalyticsEvent({}));
			onFieldUpdateFailed(err);
			return;
		}

		fireCompoundAnalyticsEvent.FieldConfig.descriptionChangedSuccess(createAnalyticsEvent({}), {
			issueFieldKey: fieldKey,
			issueFieldType: state.fields[fieldKey].type,
		});
	};
